import {
  Select as HeadlessSelect,
  SelectProps as HeadlessSelectProps,
} from '@headlessui/react'
import { cva, type VariantProps } from 'class-variance-authority'

// Remove size from HeadlessSelectProps
type SelectProps = Omit<HeadlessSelectProps, 'size'>

const selectVariants = cva(
  'border border-gray-200 text-gray-800 rounded-md w-full',
  {
    variants: {
      size: {
        small: 'h-8 text-sm py-0 px-2',
        large: 'h-12 text-lg px-4',
      },
    },
    defaultVariants: {
      size: 'small',
    },
  }
)

interface CustomSelectProps
  extends SelectProps,
    VariantProps<typeof selectVariants> {}

function Select({ size, className, ...props }: CustomSelectProps) {
  return (
    <HeadlessSelect
      className={selectVariants({ size, className })}
      {...props}
    />
  )
}

export { Select }
